module.exports = __webpack_public_path__ + "img/link04.11bcd14f.jpg";